// Avatar initials: the first letter of each of the first two words ("Acme Freight Co" -> "AF").
export const orgInitials = (name) =>
    (name || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((word) => word[0].toUpperCase())
        .join('');
